/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_A4Inputs */

const en_cad_faq_a4 = /** @type {(inputs: Cad_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Open the Use Online page and the full app loads in your browser through WebAssembly. It uses WebGPU when available and falls back to WebGL2. Chrome or Edge on a desktop computer gives the best experience.`)
};

/**
* | output |
* | --- |
* | "Yes. Open the Use Online page and the full app loads in your browser through WebAssembly. It uses WebGPU when available and falls back to WebGL2. Chrome or E..." |
*
* @param {Cad_Faq_A4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_a4 = /** @type {((inputs?: Cad_Faq_A4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_A4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_a4(inputs)
});
export { cad_faq_a4 as "cad.faq.a4" }